function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "188",
  height: "126",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_663_126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.767 55.76l.558-4.474a6.043 6.043 0 016.742-5.249 6.046 6.046 0 015.246 6.745l-.558 4.475a.812.812 0 01-.906.705l-10.377-1.295a.812.812 0 01-.705-.906z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.738 57.096a4.43 4.43 0 004.429-4.43 4.43 4.43 0 10-4.429 4.43z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.862 51.467a4.785 4.785 0 015.333-4.152l.895.111a4.784 4.784 0 014.15 5.336l-.011.09-1.891-.237-.419-1.887-.355 1.79-.977-.121-.211-.952-.179.903-6.346-.792.011-.09z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.077 68.47a2.05 2.05 0 001.361 1.063 2.039 2.039 0 001.688-.362l4.022 2.357 2.029-2.096-5.728-3.249a2.048 2.048 0 00-2.701-.355 2.056 2.056 0 00-.671 2.642z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.261 72.706c-2.967 0-8.188-1.33-8.477-1.403l-.092-.024.822-4.162 7.975 1.576 4.332-6.104 4.974-.505-.139.182c-.064.085-6.476 8.53-7.474 9.946-.252.357-.971.494-1.921.494z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.056 88.328l-.118-.057c-.026-.012-2.547-1.239-3.852-3.634-1.3-2.383 4.783-12.493 5.209-13.195l.006-3.21 2.188-5.911 2.791-1.579-2.396 5.594-3.828 21.992z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.26 122.838l-2.667-.001-1.269-10.292h3.937l-.001 10.293z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.941 125.424h-8.601v-.109a3.35 3.35 0 013.348-3.349h5.253v3.458z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.91 120.499l-2.535.831-4.409-9.385 3.74-1.226 3.204 9.78z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.361 122.745l-8.173 2.679-.034-.103a3.353 3.353 0 012.139-4.225v-.001l4.992-1.636 1.076 3.286zM167.745 118.816l-7.603-12.699-6.419-13.567-5.776 11.984-2.294 15.523-8.047.111.032-.126 12.314-48.95 9.644 1.442-.439 6.368.262.372c2.178 3.097 4.431 6.298 3.139 9.749l3.662 10.88 8.108 18.115-6.583.798z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.392 81.701c-1.397 0-2.991-1.596-2.164-4.322l-.054-.038 1.987-8.782c-1.734-2.48.552-4.528.766-4.71l1.091-1.966 4.815-3.054 2.436 20.248-.036.035c-1.76 1.684-7.668 2.59-8.841 2.59z",
  fill: "#EF8331"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.252 86.27a2.359 2.359 0 01-.568-.06c-.188-.047-.491-.285-.959-1.811-1.862-6.066-4.061-24.317-2.464-26.103l.037-.04 2.623.437c.218-.161 1.362-.96 2.417-.821a1.605 1.605 0 011.097.648l.018.024.835 11.891 3.061 13.995-.073.033c-.178.08-4.001 1.807-6.024 1.807z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.488 81.622a2.04 2.04 0 001.928-2.465l3.839-2.645-1.038-2.726-5.369 3.812a2.052 2.052 0 00.64 4.024z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.988 78.632l-3.42-2.51 4.807-6.557-3.689-6.513 1.651-4.721.107.203c.049.095 4.976 9.484 5.835 10.988.894 1.566-4.98 8.733-5.231 9.037l-.06.073z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.063 108.148l-2.91-1.226-1.997-14.597h-26.59l-2.163 14.537-2.604 1.303a.617.617 0 00.276 1.172h35.748a.621.621 0 00.606-.497.617.617 0 00-.366-.692z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.313 94.267H2.701a2.587 2.587 0 01-2.582-2.589V73.252h135.776v18.426a2.59 2.59 0 01-2.582 2.589z",
  fill: "#CCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.031 81.96H0V3.12A3.125 3.125 0 013.12 0h129.792a3.123 3.123 0 013.119 3.12v78.84z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.907 76.239H8.125a2.407 2.407 0 01-2.405-2.406V8.128a2.41 2.41 0 012.405-2.406h119.782a2.41 2.41 0 012.405 2.406v65.705a2.41 2.41 0 01-2.405 2.406z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.609 109.489H34.301a.315.315 0 01-.306-.226.305.305 0 01.294-.383h67.295a.32.32 0 01.322.238c.01.045.01.091-.001.135a.302.302 0 01-.296.236z",
  fill: "#CCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.628 16.345h-28.92v22.104h28.92V16.345z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.191 17.443H99.144V37.35h26.047V17.443z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.625 32.21l.01-.001a6.946 6.946 0 004.754-11.635 6.942 6.942 0 00-4.598-2.231.163.163 0 00-.065.008.161.161 0 00-.106.148l-.152 13.55a.158.158 0 00.157.16z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.179 20.584c.054 0 .105.022.143.06l4.663 4.771a.21.21 0 01.058.145l-.073 6.483a.203.203 0 01-.017.081.206.206 0 01-.202.12 6.99 6.99 0 01-6.372-8.136 7.007 7.007 0 011.644-3.455.205.205 0 01.148-.07h.008z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.92 18.288a.203.203 0 01.186.125.206.206 0 01.016.08l-.066 5.85c0 .041-.012.08-.035.113a.206.206 0 01-.21.085.202.202 0 01-.104-.057l-4.068-4.163a.197.197 0 01-.058-.15.201.201 0 01.069-.145 7.001 7.001 0 014.257-1.738h.013zM109.824 35.019a1.253 1.253 0 01-.783 1.144 1.247 1.247 0 11.783-1.144z",
  fill: "#0090FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.387 35.059a1.248 1.248 0 11-2.497-.027 1.248 1.248 0 012.497.027z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.951 35.099a1.253 1.253 0 01-.783 1.144 1.245 1.245 0 01-1.69-.928 1.243 1.243 0 01.544-1.275 1.25 1.25 0 011.573.173c.231.236.359.555.356.886z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.324 41.928H97.403v22.104h28.921V41.928z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.887 43.026H98.84v19.907h26.047V43.026z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.259 49.569a1.082 1.082 0 100-2.165 1.082 1.082 0 000 2.165zM120.636 47.645a.735.735 0 01.734.734.733.733 0 01-.734.733h-11.375a.732.732 0 01-.733-.733.732.732 0 01.733-.734h11.375zm0-.18h-11.375a.904.904 0 00-.646.267.912.912 0 000 1.293.915.915 0 00.646.267h11.375a.905.905 0 00.646-.267.912.912 0 00-.297-1.49.904.904 0 00-.349-.07z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.147 49.292h-8.562a.915.915 0 01-.913-.913.914.914 0 01.913-.914h8.562a.912.912 0 01.913.914.914.914 0 01-.913.913z",
  fill: "#0090FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.259 54.062a1.082 1.082 0 100-2.165 1.082 1.082 0 000 2.165zM120.636 52.138a.737.737 0 01.678.452.733.733 0 01-.678 1.015h-11.375a.732.732 0 01-.733-.734.732.732 0 01.733-.733h11.375zm0-.18h-11.375a.911.911 0 00-.913.913.911.911 0 00.913.914h11.375a.911.911 0 00.913-.914.915.915 0 00-.913-.913z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.381 53.785h-11.796a.915.915 0 01-.913-.914.914.914 0 01.913-.913h11.796a.911.911 0 01.913.913.911.911 0 01-.913.914z",
  fill: "#0090FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.259 58.554a1.082 1.082 0 100-2.164 1.082 1.082 0 000 2.164zM120.636 56.63a.737.737 0 01.678.453.733.733 0 01-.678 1.015h-11.375a.732.732 0 01-.733-.734.732.732 0 01.733-.734h11.375zm0-.18h-11.375a.911.911 0 00-.913.914.911.911 0 00.913.914h11.375a.911.911 0 00.913-.914.915.915 0 00-.913-.913z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.375 58.278h-4.79a.914.914 0 110-1.827h4.79a.913.913 0 010 1.827z",
  fill: "#0090FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.01 20.255h-80.8v41.428h80.8V20.255z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.316 22.314H12.903v37.31h75.413v-37.31z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.964 53.932H23.989a.172.172 0 01-.172-.172V27.4a.172.172 0 11.344 0v26.188h54.803a.172.172 0 110 .344z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.734 52.039h-5a.51.51 0 01-.51-.511v-6.896a.512.512 0 01.51-.51h5a.512.512 0 01.511.51v6.896a.511.511 0 01-.51.51zM44.853 52.039h-5a.511.511 0 01-.511-.511V38.092a.512.512 0 01.51-.511h5a.512.512 0 01.512.51v13.437a.511.511 0 01-.511.51zM53.972 52.039h-5a.51.51 0 01-.511-.511v-6.896a.512.512 0 01.51-.51h5a.512.512 0 01.511.51v6.896a.512.512 0 01-.51.51zM63.09 52.039h-5a.5.5 0 01-.51-.488V35.487a.5.5 0 01.51-.488h5a.5.5 0 01.51.488V51.55a.5.5 0 01-.51.488zM72.208 52.039h-5a.511.511 0 01-.51-.511V30.863a.512.512 0 01.51-.511h5a.511.511 0 01.511.51v20.666a.512.512 0 01-.51.51z",
  fill: "#0090FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.234 42.056a1.032 1.032 0 100-2.065 1.032 1.032 0 000 2.065zM42.353 35.343a1.032 1.032 0 100-2.065 1.032 1.032 0 000 2.065zM51.471 42.056a1.032 1.032 0 100-2.065 1.032 1.032 0 000 2.065zM60.59 32.073a1.032 1.032 0 100-2.065 1.032 1.032 0 000 2.065zM69.708 28.287a1.033 1.033 0 100-2.066 1.033 1.033 0 000 2.066z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.493 41.255l-9.14-6.85-9.015 6.756-.207-.275 9.222-6.91 9.096 6.816 9.04-9.897.036-.014 9.119-3.676.128.32-9.082 3.66-9.197 10.07z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.8 126h-75.994a.202.202 0 01-.141-.058.203.203 0 010-.283.202.202 0 01.141-.058H187.8a.2.2 0 110 .399z",
  fill: "#CCC"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_663_126"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h188v126H0z"
})))));